<template>
  <div class="ubiHeaderPage disFlex">
    <div :class="{'device': device === 'mobile'}" class="mainCont">
      <div class="leftCont">
        <div class="menu-list">
          <div class="menu-box-1">
            <div class="menu-title-1">
              <!-- <router-link to="/">{{ $t('ubi.home') }}</router-link> -->
              <a target="_blank" href="https://www.ubismartparcel.com">{{ $t('ubi.home') }}</a>
            </div>
          </div>
          <div v-for="parent in ubiMenuList" :key="parent.moduleUUID" :index="parent.moduleUUID" class="menu-box-1">
            <div class="menu-title-1 custom-letter-space">
              {{ parent.resourceKey }}
              <i class="el-icon-arrow-down" />
            </div>
            <template v-if="parent.children && parent.children.length > 0">
              <el-collapse-transition>
                <div class="menu-box-2">
                  <div class="menu-box-2-title-list">
                    <div v-for="child in parent.children" :key="child.moduleUUID" :index="child.path" class="menu-title-2" @click="handleSelectMenu(parent.path, child.path, parent.titleEn)">{{ child.resourceKey }}</div>
                  </div>
                </div>
              </el-collapse-transition>
            </template>
          </div>
        </div>
      </div>
      <div class="rightCont">
        <div class="right-menu">
          <!-- 个人信息 -->
          <div v-if="!name" class="login-btn" @click="loginBtn">{{ $t("common.login2") }}</div>
          <div v-if="!!name" class="menu-list">
            <div class="menu-box-1">
              <div class="menu-title-1">
                {{ name }}
                <i class="el-icon-caret-bottom" />
              </div>
              <el-collapse-transition>
                <div class="menu-box-2">
                  <div class="menu-box-2-title-list logout-box">
                    <div class="menu-title-2" @click="logout">{{ $t('ubi.logOut') }}</div>
                  </div>
                </div>
              </el-collapse-transition>
            </div>
          </div>
          <!-- 语言切换 -->
          <lang-select class="right-menu-item" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LangSelect from './components/LangSelect'
import { logout, queryMenu, queryMenuNew } from '@/api/user'
import { formatMenuList } from '@/utils/common'
import baseUrl from '@/utils/baseUrl'
export default {
  components: {
    LangSelect
  },
  data() {
    return {
      baseURL: baseUrl,
      isShowBottom: true,
      isShowPasswordDialog: false
    }
  },
  computed: {
    ...mapGetters(['menuList', 'name', 'language', 'token', 'device']),
    ubiMenuList() {
      const menuList = this.menuList
      if (this.language === 'en') {
        // 英文状态下全部大写
        menuList.map(item => {
          item.resourceKey = item.resourceKey.toLocaleUpperCase()
          item.children && item.children.map(child => {
            child.resourceKey = child.resourceKey.toLocaleUpperCase()
          })
        })
      }
      return menuList
    }
  },
  watch: {
    token: function(newValue, oldValue) {
      if (newValue) {
        if (this.menuList.length <= 0) this.getMenuListNew()
      }
    }
  },
  created() {
    if (this.menuList.length <= 0 && this.token) this.getMenuListNew()
    if (!this.token) this.$store.dispatch('user/logout')
  },
  methods: {
    loginBtn() {
      // let language = ''
      // if (this.language === 'zh') {
      //   language = 'zh_CN'
      // } else if (this.language === 'en') {
      //   language = 'en_US'
      // }
      // let href = loginSystem({
      //   returnUrl: window.location.origin + '/#/index',
      //   brand: 'smartparcel.gotoubi.com',
      //   language
      // })
      // window.location.href = href
      this.$router.push({
        path: '/login'
      })
    },
    handleSelectMenu(parentPath, url, parentTitleEn) {
      let host = window.location.host
      const { origin, hostname = '' } = location
      // const sysUrl = pathname.split('/')[1]
      if (hostname !== 'localhost') {
        let path = 'shipper'
        if (parentTitleEn === 'Logistor') path = 'logistor'
        else if (parentTitleEn === 'Integrator') path = 'aggregator'
        parentPath = origin + '/' + path
      }
      let newHref = `${parentPath}/#/sessionRedirect?brand=${host}&language=${this.language === 'zh' ? 'zh_CN' : 'en_US'}&redirect=${url}&type=switch`
      if (this.token) newHref += '&sessionId=' + this.token
      window.open(newHref, '_blank')
    },
    // 获取菜单
    getMenuList() {
      queryMenu().then(res => {
        this.$store.dispatch('user/set_menuList', res.data)
      }, () => {
        this.$store.dispatch('user/logout').then(() => {
          window.location.reload()
        })
      })
    },
    // 获取菜单 新
    getMenuListNew() {
      const params = {
        sessionId: this.token
      }
      queryMenuNew(this.baseURL, params).then(res => {
        const menu = formatMenuList(res.data, this.language)
        // console.log(menu)
        this.$store.dispatch('user/set_menuList', menu)
      }, () => {
        this.$store.dispatch('user/logout').then(() => {
          window.location.reload()
        })
      })
    },
    async logout() {
      logout(this.baseURL, { sessionId: this.$store.getters.token })
      this.$store.dispatch('user/logout').then(() => {
        window.location.reload()
      })
    }
  }
}
</script>
<style lang='scss' scoped>
  .ubiHeaderPage {
    background-color: $menuBgcOragne;
    .mainCont {
      width: 1200px;
      &.device {
        width: 900px;
      }
      background-color: $menuBgcOragne;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 50px;
      .leftCont {
        height: 100%;
      }
      .rightCont {
        height: 100%;
        .right-menu {
          height: 100%;
          .menu-list {
            display: inline-block;
          }
          .login-btn {
            display: inline-block;
            font-size: 15px;
            height: 100%;
            background-color: $menuActiveColor;
            font-family: $fontFamilyArialBoldMT;
            color: #fff;
            cursor: pointer;
            font-weight: bold;
            width: 134px;
            text-align: center;
            line-height: 50px;
            margin-right: 10px;
          }
        }
      }
    }
    .menu-list {
      display: block;
      height: 100%;
      font-size: 0;
      .menu-box-1 {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        height: 100%;
        z-index: 1;
        &:hover {
          .menu-title-1 {
            color: #fff;
          }
          .menu-box-2 {
            display: block;
          }
        }
        .menu-title-1 {
          cursor: pointer;
          height: 100%;
          display: flex;
          align-items: center;
          background-color: $menuBgcOragne;
          font-size: 15px;
          color: $menuActiveColor;;
          font-family: $fontFamilyArialBoldMT;
          font-weight: bold;
          padding: 0 13px 0 14px;
          margin-right: 1px;
          position: relative;
          &.custom-letter-space {
            letter-spacing: 1px;
          }
          [class*=" el-icon-"], [class^=el-icon-] {
            color: $menuActiveColor;
            font-weight: bold;
          }
          &::before {
            display: block;
            content: '';
            height: 14px;
            width: 2px;
            background-color: $menuActiveColor;
            position: absolute;
            right: -1px;
          }
        }
        .menu-box-2 {
          display: none;
          padding-top: 27px;
          cursor: pointer;
          position: absolute;
          background-color: $menuBgcBox2Blue;
          overflow: hidden;
          top: 100%;
          border-bottom-left-radius: 20px;
          border-bottom-right-radius: 20px;
          &::before {
            display: block;
            content: '';
            width: 20px;
            height: 20px;
            background-color: $menuBgcOragne;
            position: absolute;
            top: -10px;
            transform: rotateZ(45deg);
            transform-origin: center;
            left: 50%;
            margin-left: -10px;
          }
          .menu-box-2-title-list {
            padding: 0 6px 25px;
            max-height: 80vh;
            overflow: scroll;
            &.logout-box {
              min-width: 180px;
              padding-bottom: 9px;
            }
            &::-webkit-scrollbar {
              display: none;
            }
          }
          .menu-title-2 {
            margin: 7px 0;
            text-align: center;
            text-wrap: nowrap;
            color: #fff;
            font-family: $fontFamilyArialMT;
            font-size: 14px;
            &:hover {
              color: $menuActiveColor;
            }
          }
        }
      }
      .menu-box-1:nth-last-child(1) {
        .menu-title-1 {
          &::before {
            display: none;
          }
        }
      }
    }
  }
</style>
